import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";
import { setCustomDomainTenant } from "./lib/tenant";
import { configApi } from "./lib/api/client";

// Fetch the browser Maps key once before the first render so the Places library is available app-wide
// without a remount. If config is unavailable, the app still renders and address inputs degrade to
// plain text fields.
async function bootstrap() {
  let mapsKey = "";
  try {
    const config = await configApi.get();
    mapsKey = config.googleMapsApiKey ?? "";
    setCustomDomainTenant(config.customDomainTenant ?? null);
  } catch {
    /* degrade: render without Maps */
  }

  const { router } = await import("./router");
  const app = <RouterProvider router={router} />;

  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      {mapsKey ? <APIProvider apiKey={mapsKey} libraries={["places"]}>{app}</APIProvider> : app}
    </React.StrictMode>,
  );
}

void bootstrap();
